import React from 'react';
// import FooterLinks from './FooterLinks';
import MenuMobile from './MenuMobile';

const Footer = () => {
    return (
        <section className='flex flex-col w-full'>

            {/* <FooterLinks /> */}

            <section className='fixed md:hidden z-30 w-full h-16 bottom-0'>
                <MenuMobile />
            </section>

        </section>
    );
};

export default Footer;
